angular.module('ecrd.states').config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push(['$q', '$log', '$injector', function($q, $log, $injector) {
        return {
            responseError: function(response) {
                if (angular.isObject(response.data) && response.data.code === 'sign-action-max-attemps-reached') {
                    // Services must be loaded using "$injector" to avoid cyclic dependencies error
                    var AccountManager = $injector.get('AccountManager');
                    var SecurityRedirect = $injector.get('SecurityRedirect');

                    return AccountManager.logout()
                        .catch(function(error) {
                            $log.error(error, 'logout after expired session');
                        })
                        .then(function() {
                            SecurityRedirect.redirect(response.data.code);

                            return $q(function() {
                                // Esta promesa no se resuelve nunca. Es la manera de parar la cadena de promesas
                                // mientras el navegador redirige a la página de login
                            });
                        });
                }

                return $q.reject(response);
            },
        };
    }]);
}]);
